var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.653,
    height: 22,
    viewBox: "0 0 25.653 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10226",
    "data-name": "Path 10226",
    d: "M24.111,41.041a1.835,1.835,0,0,0-.317-.024H5.7l.395-.184A3.671,3.671,0,0,0,7.127,40.1L12.2,35.025a1.9,1.9,0,0,0,.266-2.432,1.835,1.835,0,0,0-2.753-.239L.538,41.531a1.835,1.835,0,0,0,0,2.6h0l9.177,9.177a1.835,1.835,0,0,0,2.753-.184A1.9,1.9,0,0,0,12.2,50.69L7.136,45.606a3.671,3.671,0,0,0-.918-.67l-.551-.248H23.692a1.9,1.9,0,0,0,1.936-1.542A1.835,1.835,0,0,0,24.111,41.041Z",
    transform: "translate(0 -31.842)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterbtn);
export default __webpack_public_path__ + "static/media/footerbtn.205aed3e4be0f79727377ac081469139.svg";
export { ForwardRef as ReactComponent };